<template>
    <div class="print" ref="printContent">
        <table width="100%" border="1" align="center">
            <tr align="center">
                <td colspan="9"><strong style="font-size:25px">抽检确认单</strong></td>
            </tr>
            <tr>
                <td width="18%">供应商名称：</td>
                <td colspan="6">{{ fullUnitName }}</td>
                <td width="100px">
                    <img width="100px" src="https://res.devlist.top/Upload/qrcode.png" />
                </td>
            </tr>
            <tr align="center">
                <td colspan="8">中标设备、材料名称规格数量</td>
            </tr>
            <tr>
                <td>工程名称</td>
                <td>报装编号</td>
                <td>物料名称</td>
                <td>型号规格</td>
                <td>数量</td>
                <td>单位</td>
                <td>联系人</td>
                <td>地点</td>
            </tr>
            <tr v-for="item in printObj" :key="item.b_id">
                <td>{{ item.a_projectName }}</td>
                <td>{{ item.a_bzNo }}</td>
                <td>{{ item.a_materialName }}</td>
                <td>{{ item.a_model }}</td>
                <td>{{ item.b_num || 0 }}</td>
                <td>{{ item.a_unit }}</td>
                <td>{{ item.b_linkman }}<br />{{ item.b_linkphone }}</td>
                <td>{{ item.b_address }}</td>
            </tr>
        </table>
    </div>
</template>
<script>
import { get_print_list } from "@/api";
export default {
    data() {
        return {
            content: this.$route.query.c,
            printObj: [],
            fullUnitName: ""
        }
    },
    mounted: function () {
        let c = JSON.parse(this.content);
        this.fullUnitName = c.fun;
        let params = {
            limit: 10,
            page: 0,
            searchCondition: {
                ids: c.item
            },
        }
        get_print_list(params).then((res) => {
            console.log(res);
            this.printObj = res.list;
        });
    }
}
</script>
